module.exports = __webpack_public_path__ + "media/wood-duck-1.f4b14e9f.mp3";